import { Typography } from 'antd'
import React from 'react'
import './title.css'

const { Title } = Typography

const TitleD = ({ text, size, marginTop = 10 }) => (
  <Title
    className="Title"
    level={Number(size)}
    style={{ marginTop: Number(marginTop) }}
  >
    {text}
  </Title>
)

export default TitleD
